import { useState, useEffect, useContext } from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { DAYS, DAY_LABELS, formatTime } from "../utils/helpers";
import { SiteSettingsContext } from "../contexts";

const ContactView = ({ setView }) => {
  const { settings: siteSettingsData } = useContext(SiteSettingsContext);
  const [info, setInfo] = useState({ support_email: "", contact_phone: "", contact_address1: "", contact_address2: "", contact_city: "", contact_state: "", contact_zip: "", show_hours: true, hours: null });

  useEffect(() => {
    if (!siteSettingsData) return;
    let hours = null;
    if (siteSettingsData.business_hours) {
      try { hours = JSON.parse(siteSettingsData.business_hours); } catch {}
    }
    setInfo({ ...siteSettingsData, hours });
  }, [siteSettingsData]);

  return (
    <div style={{ maxWidth: 680, margin: "0 auto", padding: "64px 24px 80px" }} className="fade-up">
      <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", letterSpacing: "0.18em", color: "var(--amber)", textTransform: "uppercase", marginBottom: 12 }}>Get in touch</p>
      <h1 style={{ fontSize: "clamp(32px, 5vw, 52px)", lineHeight: 1.05, letterSpacing: "-0.02em", marginBottom: 40 }}>Contact us</h1>

      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {info.support_email && (
          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "24px 28px" }}>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.1em", marginBottom: 8 }}>EMAIL</p>
            <a href={`mailto:${info.support_email}`} style={{ fontSize: "17px", color: "var(--amber)", textDecoration: "none", wordBreak: "break-all" }}>{info.support_email}</a>
          </div>
        )}
        {info.contact_phone && (
          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "24px 28px" }}>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.1em", marginBottom: 8 }}>PHONE</p>
            <a href={`tel:${info.contact_phone}`} style={{ fontSize: "17px", color: "var(--text)", textDecoration: "none" }}>
              {formatPhoneNumberIntl(info.contact_phone) || info.contact_phone}
            </a>
          </div>
        )}
        {info.contact_address1 && (
          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "24px 28px" }}>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.1em", marginBottom: 8 }}>ADDRESS</p>
            <p style={{ fontSize: "15px", color: "var(--text)", lineHeight: 1.7 }}>
              {info.contact_address1}<br />
              {info.contact_address2 && <>{info.contact_address2}<br /></>}
              {[info.contact_city, info.contact_state].filter(Boolean).join(", ")}{info.contact_zip ? ` ${info.contact_zip}` : ""}
            </p>
          </div>
        )}
        {info.show_hours !== false && info.hours && (
          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "24px 28px" }}>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.1em", marginBottom: 14 }}>HOURS</p>
            {DAYS.map((day, i) => {
              const d = info.hours[day];
              if (!d) return null;
              return (
                <div key={day} style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 6 }}>
                  <span style={{ fontSize: "15px", color: "var(--text-dim)" }}>{DAY_LABELS[i]}</span>
                  <span style={{ fontFamily: "var(--font-mono)", fontSize: "13px", color: d.closed ? "var(--text-muted)" : "var(--text)" }}>
                    {d.closed ? "Closed" : `${formatTime(d.open)} – ${formatTime(d.close)}`}
                  </span>
                </div>
              );
            })}
          </div>
        )}
        {!info.support_email && !info.contact_phone && !info.contact_address && (
          <p style={{ color: "var(--text-dim)", fontSize: "15px" }}>Contact information not yet configured.</p>
        )}
      </div>
    </div>
  );
};

export default ContactView;
